import { use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';
import { ESettingsWorkspaceTab } from '../ESettingsWorkspaceTab';
import { TabSettingsWorkspaceWrapper } from '../_base/TabSettingsWorkspaceWrapper';
import { WSButtonGoToWorkspace } from './_buttons/WSButtonGoToWorkspace';

export function TabSettingsWorkspaceUserInvitationsPersonal() {
  const { workspace_current, workspaces_map } = use_slice_workspace(['workspace_current', 'workspaces_map']);

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  /*
   * RENDERS
   */

  function render_button_go_to_workspace() {
    let workspaces = Array.from(workspaces_map.values()).filter(item => !item.is_personal);

    return workspaces.map(workspace => <WSButtonGoToWorkspace key={`button_go_to_workspace_${workspace._id}`} workspace={workspace} />);
  }

  /*
   * HTML
   */
  if (!workspace_current.is_personal) return <></>;

  return (
    <TabSettingsWorkspaceWrapper type={ESettingsWorkspaceTab.USERS}>
      <div className="flex flex-col justify-start items-start mt-2 gap-3  text-page-foreground">
        <span className="text-xl">{t(i18n_page_settings_workspace.tabs.users.personal.title)}</span>
        <span>{t(i18n_page_settings_workspace.tabs.users.personal.description)}</span>
        <div className="flex flex-col gap-2">{render_button_go_to_workspace()}</div>
      </div>
    </TabSettingsWorkspaceWrapper>
  );
}
